import { AccessibilityLocales } from './locales/accessibility';
import { CartLocales } from './locales/cart';
import { CommonLocales } from './locales/common';
import { ErrorLocales } from './locales/error';
import { NavigationLocales } from './locales/navigation';
import { ProductErrors } from './locales/product';
import { TimeLocales } from './locales/time';

export const ErrorSection = 'error';

export const STORE_LOCALES = {
	productErrors: ProductErrors,
	accessibility: AccessibilityLocales,
	cart: CartLocales,
	common: CommonLocales,
	error: ErrorLocales,
	navigation: NavigationLocales,
	time: TimeLocales,
};
